import { useHistory } from "react-router";
import { usePublicCalendarContext } from "./use_public_calendar_context";

export function useHistoryPusher() {
	const history = useHistory();
	const { is_public } = usePublicCalendarContext();

	return (url: string) =>
		is_public ? (window.location.href = url) : history.push(url);
}
